export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-hospitals.png-aa3f20bfc7f0455b6444ae6142927dd9.jpg";